<template>
<div>
    <div class="main-header">
        <div class="container">
            <h2 class="main-header-text">Login to Continue</h2>
        </div>
    </div>
    <div class="main-section mgt-40">
        <div class="container">

            <div class="main-card">
                <img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

                <div class="phrase-content">
                    <div class="content-inner">
                        <div class="confirmation sp">
                            <div>
                                <strong> Security Phrase </strong>
                                <p> Is your Security Phrase </p>
                                <h2 class="text-uppercase"> {{vModel.passphrase}} </h2>
                            </div>

                            <div class="form-group box-width">
                                <label>Please Enter Password</label>
                                <span class="pass"> Password</span>
                                <div class="input-group">
                                    <input autocomplete="off" v-model="vModel.password" data-vv-as='Password' v-drag-disable='' v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('userpassword'),'form-control' : true }" :type="showPassword ?'text':'password'" placeholder="Password" name="userpassword" />
                                    <div class="input-group-append toggle-hide" @click="showPassword=!showPassword">
                                        <span class="input-group-text" id="basic-addon3">{{showPassword ? 'HIDE' : 'SHOW'}}</span>
                                    </div>
                                </div>

                                <div v-show="errors.has('userpassword')" class="help is-danger">{{ errors.first('userpassword') }}</div>

                                <div style="margin-top:5px" v-if="vModel.HasLoginErrorMessage && vModel.LoginAttemptErrorMessage" class="help is-danger"> {{vModel.LoginAttemptErrorMessage}}</div>
                            </div>

                            <router-link :to="'forgotpassword'" class="forgot-password">Forgot Password?</router-link>
                        </div>
                        <!--end confirmation.sp-->
                        <div class="button-wrap ">
                            <button class="btn btn-next" type="button" @click="$parent.onPasswordSubmit">LOGIN</button>
                            <br />
                            <!-- Loading Spinner -->
                            <div v-show="vModel.loading">
                                <pulse-loader :color="color" :size="size" :margin="margin" :radius="radius"></pulse-loader>
                            </div>
                        </div>
                    </div>
                    <!--end Content inner-->
                </div>
                <!--end content-->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
    name: "loginpassword",
    inject: ['$validator'],
    props: ["vModel"],
	components: {
		PulseLoader
	},
    data() {
        return {
            showPassword: false
        }
    },
}
</script>
<style  scoped>
    @media(min-width:768px){
        .form-group.box-width {
        max-width: 35% !important;
    }
    }
</style>
